export default "__VITE_ASSET__1ae1fbd3__"